module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/BEST_DEALS.e424f7e3.svg";